import { render } from "./TreeDictionary.vue?vue&type=template&id=e46edeec&scoped=true"
import script from "./TreeDictionary.vue?vue&type=script&lang=js"
export * from "./TreeDictionary.vue?vue&type=script&lang=js"

import "./TreeDictionary.vue?vue&type=style&index=0&id=e46edeec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e46edeec"]])

export default __exports__